// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__Z_akX","loading":"Loading_loading__ar2pP","icon":"Loading_icon__xn86S","text":"Loading_text__HZPXu"};